import { InfiniteData } from '@tanstack/react-query'

export const flattenPages = (
  data: InfiniteData<unknown, unknown> | undefined,
  key: string
): unknown =>
  (data?.pages || []).flatMap(
    (page) => (page as Record<string, string>)[key] || []
  )
